import { render } from "./Portfolio.vue?vue&type=template&id=474ee542"
import script from "./Portfolio.vue?vue&type=script&lang=js"
export * from "./Portfolio.vue?vue&type=script&lang=js"
script.render = render

export default script